<script setup lang="ts">
import SocialMediaButtons from "@/components/Common/SocialMediaButtons.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'GameInfo',

    data() {
        return {
        }
    },
})
</script>

<template>
    <div class="info">
        <h5>Приветствуем тебя, пилот!</h5>
        <p><span class="highlighted">«Космические Скауты»</span> - это браузерная многопользовательская пошаговая игра на космическую тему.</p>
        <p>Здесь тебя ждут увлекательные бои, межпланетные и межзвёздные путешествия, правительственные квесты, торговля, колонизация планет, крафт, профессии, кланы и многое другое!</p>

        <SocialMediaButtons/>
    </div>
</template>

<style scoped lang="scss">
.info {
    width: 100%;
    text-align: center;
    color: white;

    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    box-shadow: 0 0 10px 2px black;
    padding: 5px 10px 5px 10px;
}

h5 {
    color: orangered;
}

.highlighted {
    color: #f5c88b;
}

p {
    text-align: center;
    margin-bottom: 10px;
}
</style>
